import { useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ProcessSection from "@/components/ProcessSection";
import ResultsSection from "@/components/ResultsSection";
import FAQSection from "@/components/FAQSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";

export default function LandingPage() {
  const [showForm, setShowForm] = useState(false);

  const scrollToForm = () => {
    const formElement = document.getElementById("contact-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main className="min-h-screen bg-white">
      {/* SEO Meta handled in index.html */}
      <Header />
      <HeroSection onCTAClick={scrollToForm} />
      <WhyChooseUs />
      <ProcessSection />
      <ResultsSection />
      <FAQSection />
      <TestimonialsSection />
      <ContactForm />
      <Footer />
      <StickyCTA onCTAClick={scrollToForm} />
    </main>
  );
}
